import { getColorVariantFromBackground } from '@klv/shared/utils/functions';
import * as s from './styles';

import type { TIconName } from '@klv/atoms/icon/types';
import type { ICard } from './types';


const Card = ({
  bodyCopy,
  buttons,
  icon = { iconName: '' },
  variant = 'light',
  title,
  iconSize = 3.2,
  ...props
}: ICard) => (
  <s.StyledCard $variant={variant} {...props}>
    <s.StyledIcon
      color='currentColor'
      iconName={icon?.iconName as TIconName}
      $variant={variant}
      size={iconSize}
    />
    <s.CardHeadline
      colorVariant={getColorVariantFromBackground(variant)}
      variant='h6Semibold'
      forwardedAs='h3'
    >
      {title}
    </s.CardHeadline>
    <s.StyledCopy
      colorVariant={getColorVariantFromBackground(variant)}
      variant='paragraph2'
      dangerouslySetInnerHTML={{ __html: bodyCopy }}
    />
    {buttons !== undefined && (
      <s.StyledButtons
        buttonColor={variant === 'light' ? 'dark' : 'light'}
        buttons={buttons}
        variants={['tertiary']}
      />
    )}
  </s.StyledCard>
);

export default Card;
